import { BaseService } from "../../core/baseService";
import {
  CannedResponse,
  CannedResponseCategory,
  CannedResponseServiceInterface,
  CreateCannedResponseDto,
  UpdateCannedResponseDto,
} from "../types/cannedResponse.types";
import { ApiResult } from "../../core/types";

export class CannedResponseService
  extends BaseService
  implements CannedResponseServiceInterface
{
  async getAll(activeOnly = true): Promise<ApiResult<CannedResponse[]>> {
    return this.handleRequest<CannedResponse[]>(
      this.client.get("/api/admin/canned-responses", {
        params: { activeOnly },
      })
    );
  }

  async getGroupedByCategory(): Promise<ApiResult<CannedResponseCategory[]>> {
    return this.handleRequest<CannedResponseCategory[]>(
      this.client.get("/api/admin/canned-responses/grouped")
    );
  }

  async getById(id: string): Promise<ApiResult<CannedResponse>> {
    return this.handleRequest<CannedResponse>(
      this.client.get(`/api/admin/canned-responses/${id}`)
    );
  }

  async create(
    data: CreateCannedResponseDto
  ): Promise<ApiResult<CannedResponse>> {
    return this.handleRequest<CannedResponse>(
      this.client.post("/api/admin/canned-responses", data)
    );
  }

  async update(
    id: string,
    data: UpdateCannedResponseDto
  ): Promise<ApiResult<CannedResponse>> {
    return this.handleRequest<CannedResponse>(
      this.client.put(`/api/admin/canned-responses/${id}`, data)
    );
  }

  async delete(id: string): Promise<ApiResult<void>> {
    return this.handleRequest<void>(
      this.client.delete(`/api/admin/canned-responses/${id}`)
    );
  }
}
